<template>
    <div>
        <el-row style="display: flex;margin-bottom: 10px;">
            <el-col :span="14" >
                <el-select v-model="form.projectId" @change="theProjectAllChange" size="small" filterable clearable
                    placeholder="请选择项目" v-if="theProjectId == 0">
                    <el-option v-for="item in getProjectList_data.data || []" :key="item.projectId"
                        :label="item.projectName" :value="item.projectId">
                    </el-option>
                </el-select>
                <el-select v-model='form.ytsdId' clearable filterable size="small" @change="theProjectAllChange">
                    <el-option v-for="item in getTemStatisticDepartmentList_data.data || []" :key="item.ytsdId"
                        :label="item.ytsdName" :value="item.ytsdId">
                    </el-option>
                </el-select>
                <el-button v-if="uploadTemStatisticUser"
                    @click=" $form('uploadTemStatisticUser'), tabledataAll = [], row = {}" size='small' type="primary"
                    style="float:right;margin-right: 20px;" icon='el-icon-circle-plus'>批量导入
                </el-button>
            </el-col>

        </el-row>
        <div>
            <myform :viewobj='{

                updateTemStatisticUser: ["修改人员数据", "el-icon-edit-outline"],
                $succeed$: getTemStatisticUserList
            }'>
                <template v-slot:ytsdId="{ Myformdata }">
                    <el-select v-model='Myformdata.ytsdId' clearable filterable>
                        <el-option v-for="item in getTemStatisticDepartmentList_data.data || []" :key="item.ytsdId"
                            :label="item.ytsdName" :value="item.ytsdId">
                        </el-option>
                    </el-select>
                </template>
                <hide slot='projectId' />
                <hide slot='ytsuId' />

            </myform>
            <mytable :tableColums='tableColums_getTemStatisticUserList' api='getTemStatisticUserList'
                xupdateapi='updateOpportunityBusinessCheckImage' :height="H - 165">
            </mytable>
        </div>
        <myform view.uploadTemStatisticUser="批量导入" @close='$form("uploadTemStatisticUser", "hide")'>
            <el-row>
                <el-col :span="4" style="min-width:100px;">
                    <el-button type="primary" @click="toDownExcel">下载<i
                            class="el-icon-download el-icon--right"></i></el-button>
                </el-col>
                <el-col :span="20">
                    <el-upload ref="uploadAll" action="#" :limit="1" :auto-upload="false" :show-file-list="true"
                        :on-change="onChangeContent">
                        <el-button type="primary">上传<i class="el-icon-upload el-icon--right"></i></el-button>
                    </el-upload>
                </el-col>
            </el-row>
            <el-table :data="tabledataAll" v-if="(tabledataAll || '').length > 0" max-height="400">
                <el-table-column prop="status" label="状态" width="120">
                </el-table-column>
                <el-table-column prop="statusMsg" label="原因" width="120">
                </el-table-column>
                <el-table-column prop="ytsdName" label="战队名称">
                </el-table-column>
                <el-table-column prop="ytsuName" label="姓名">
                </el-table-column>
                <el-table-column prop="ytsuPost" label="职位">
                </el-table-column>
                <el-table-column prop="ytsuOne" label="个人续费条数">
                </el-table-column>
                <el-table-column prop="ytsuTwo" label="个人企宽到期总量">
                </el-table-column>


            </el-table>
            <!-- <div style="width:100%; margin: 60px auto 20px;text-align: right;">
                <el-button @click="bulkImportClose">取 消</el-button>
                <el-button type="success" @click="bulkImportClick">确定导入</el-button>
            </div> -->
        </myform>
    </div>
</template>
  
<script>
import myhttp from '../../utils/myhttp';
import qs from 'qs';
import axios from 'axios';
export default {
    data() {
        return {
            baseUrl: $Api.baseUrl_online,
            tabledataAll: [],
            theProjectId: 0,
            value: '',
            form: {
                ytsdId:'',
                projectId: '',
                yasDate: '',
                yasCommand: '',
                yasTimeStart: '',
                yasTimeEnd: '',
                yasDes: '',
            },
            tableColums_getTemStatisticUserList: {
                $selection: false,

                // oiType: '限制字段key',

                ytsuName: '姓名',
                ytsuPost: '职位',
                ytsuOne: '个人续费条数',
                ytsuTwo: '个人企宽到期总量',


                $operation: [
                    '操作', 200,
                    this.updateTemStatisticUser && `@text: 编辑#success
               @click: $form("updateTemStatisticUser",$row)
              `,
                    //         this.deleteProjectPropSpecialist && `@text: 删除#danger
                    //    @click: _confirm('确定要删除该填写项约束吗?')
                    //            .trigger('deleteProjectPropSpecialist',{yppsId:$row.yppsId})
                    //            .trigger('getTemStatisticUserList',{projectId:form.projectId})
                    //   `,
                ],
            }
        }
    },
    methods: {
        openLoading() {
            //loading请求等待
            this.loading = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        doupload: async function (file) {
            let param = new FormData(); // 创建form对象
            param.append("file", file); // 通过append向form对象添加数据
            if (this.row && this.row.projectId) {
                param.append("projectId", this.row.projectId);
            }
            console.log(param)
            const loading = $Loading();
            const responseData = await myhttp.postFileUsers("/trainingmsg/tem-statistic-user/uploadTemStatisticUser", param);
            loading.close();
            if (responseData.data.result == "success") {
                this.$message({
                    type: "success",
                    message: "上传成功!"
                });
            } else {
                this.$message({
                    type: "error",
                    message: "上传失败!"
                });
            }
            return responseData
        },
        async onChangeContent(files, fileList) {
            const table = await this.doupload(files.raw);
            this.tabledata = table.data.data.data.sysImportTem;
            this.tabledataAll = table.data.data.data.resultList;
            //    this.getUserTargetList();
            if (this.$refs.upload) {
                this.$refs.upload.clearFiles();  //清空文件
            }
            if (this.$refs.uploadAll) {
                this.$refs.uploadAll.clearFiles();  //清空文件
            }
        },
        toDownExcel() {
            myhttp.downloadFile("https://trainapp.aojuai.com/trainai/excel/temuser.xlsx", "临时战队.xlsx");
        },
        myform(submit, Myformdata) {
            Myformdata.projectId = this.form.projectId;
            submit();
        },
        theProjectAllChange(e) {
            // if (e == '') {
            //     return this.form.projectId = e;
            // }
            // this.form.projectId = e;
            this.getTemStatisticUserList({ projectId: this.form.projectId, ytsdId: this.form.ytsdId })
        },
    },
  async  created() {
        this.getProjectList({
            pageSize: 0
        });

        this.theProjectId = A.local("$projectId");
        if (this.theProjectId != 0) {
            this.form.projectId = this.theProjectId;
        }
        this.getTemStatisticDepartmentList({ projectId: this.form.projectId, pageSize: 0 }).result(res =>{
            const s = res.data.data
            this.form.ytsdId = s[0].ytsdId
            this.getTemStatisticUserList({ projectId: this.form.projectId,ytsdId:s[0].ytsdId })
   
        })
    },  
       
}
</script>
  
<style scoped></style>
  


// WEBPACK FOOTER //
// src/views/data/ephemeralUser.vue